<template>
  <div class="secondPageCon">
    <div v-if="cWidth > 1024">
      <!-- 导航 -->
      <div class="secondPageNav">
        <div class="w1200">
          <ul>
            <li>
              <router-link :to="{ path: '/index' }">
                <a>首 页</a>
              </router-link>
            </li>
            <li v-for="(item, index) in navList" :key="index">
              <router-link
                :to="{
                  path: '/secondpage',
                  query: { index: index, secondindex: 0, thirdindex: '-1' },
                }"
              >
                <a
                  @click="
                    firstIndex = index;
                    secondIndex = 0;
                    secondList = navList[firstIndex].second;
                  "
                  >{{ item.first }}</a
                >
              </router-link>
              <div class="second_nav">
                <p v-for="(item2, index2) in item.second" :key="index2">
                  <router-link
                    :to="{
                      path: '/secondpage',
                      query: {
                        index: index,
                        secondindex: index2,
                        thirdindex: '-1',
                      },
                    }"
                  >
                    {{ item2.title }}
                  </router-link>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="app_header" v-else>
      <div class="app_top_left_logo">
        <img src="../assets/img/logo_mini.jpg" alt="" srcset="" />
      </div>
      <input
        id="toggle"
        type="checkbox"
        v-model="isAppNavShow"
        @change="
          isAppNavShow = true;
          currentNav = -1;
        "
      />

      <label for="toggle" class="hamburger">
        <div class="top-bun"></div>
        <div class="meat"></div>
        <div class="bottom-bun"></div>
      </label>
      <div class="nav" v-if="isAppNavShow">
        <div class="nav-wrapper">
          <nav>
            <div class="app_nav_right_nav">
              <ul>
                <li @click="isAppNavShow = false">
                  <router-link :to="{ path: '/index' }">
                    <span class="reo" style="display: block">首页</span>
                  </router-link>
                </li>
                <li v-for="(item, index) in navList" :key="index">
                  <a @click="appNavClick(index)">
                    <span class="reo" style="display: block">{{
                      item.first
                    }}</span>
                    <span
                      class="iconfont icon-xiajiantou2-copy youjt"
                      v-if="currentNav == index"
                    ></span>
                    <span class="iconfont icon-youjiantou2 youjt" v-else></span>
                  </a>
                  <div class="one_nav" v-if="currentNav == index">
                    <ul>
                      <li
                        v-for="(item2, index2) in item.second"
                        :key="index2"
                        @click="isAppNavShow = false"
                      >
                        <router-link
                          :to="{
                            path: '/secondpage',
                            query: {
                              index: index,
                              secondindex: index2,
                              thirdindex: '-1',
                            },
                          }"
                        >
                          <p>{{ item2.title }}</p>
                        </router-link>
                        <div class="one_second_nav" v-if="item2.children">
                          <ul>
                            <li
                              v-for="(item3, index3) in item2.children"
                              :key="index3"
                              @click="isAppNavShow = false"
                            >
                              <router-link
                                :to="{
                                  path: '/secondpage',
                                  query: {
                                    index: index,
                                    secondindex: index2,
                                    thirdindex: index3,
                                  },
                                }"
                              >
                                <p>{{ item3.title }}</p>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- 页头 -->
    <div class="pageTop">
      <div class="w1200">
        <p style="display: inline-block" v-if="cWidth > 1024">
          您当前的位置 ：
        </p>
        <router-link :to="{ path: '/index' }">
          <a>首页</a>
        </router-link>
        <!-- >> -->
        <span class="iconfont icon-arrowrightdl"></span>
        <router-link
          :to="{
            path: '/secondpage',
            query: { index: firstIndex, secondindex: 0 },
          }"
        >
          <a>{{ navList[firstIndex].first }}</a>
        </router-link>
        <!-- >> -->
        <span class="iconfont icon-arrowrightdl"></span>
        <router-link
          :to="{
            path: '/secondpage',
            query: {
              index: firstIndex,
              secondindex: secondIndex,
              thirdindex: '-1',
            },
          }"
        >
          <a>{{ navList[firstIndex].second[secondIndex].title }}</a>
        </router-link>
        <span
          v-if="thirdIndex != '-1'"
          class="iconfont icon-arrowrightdl"
        ></span>
        <router-link
          v-if="thirdIndex != '-1'"
          :to="{
            path: '/secondpage',
            query: {
              index: firstIndex,
              secondindex: secondIndex,
              thirdindex: thirdIndex,
            },
          }"
        >
          <a>{{
            navList[firstIndex].second[secondIndex].children[thirdIndex].title
          }}</a>
        </router-link>
      </div>
    </div>
    <Content></Content>
  </div>
</template>     

<script>
import $ from "jquery";
import Content from "../components/SecondPage/SecondContent.vue";
export default {
  name: "",
  components: {
    Content,
  },
  data() {
    return {
      cWidth: sessionStorage.getItem("clientWidth"),
      isAppNavShow: false,
      currentNav: -1,
      navList: this.NavList,
      firstIndex: this.$route.query.index,
      secondIndex: this.$route.query.secondindex || 0,
      thirdIndex: this.$route.query.thirdindex || "-1",
    };
  },
  created() {},
  mounted() {
    $(window).scrollTop(0);
    $(".secondPageNav li").mouseover(function () {
      $(this)
        .children("")
        .next(".second_nav")
        .stop(true, true)
        .delay(200)
        .slideDown(200);
    });
    $(".secondPageNav li").mouseleave(function () {
      $(this)
        .children("")
        .next(".second_nav")
        .stop(true, true)
        .delay(200)
        .slideUp(100);
    });
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号
      deep: true,
      immediate: true,
      handler(to, from) {
        // console.log("路由变化了");
        // console.log("当前页面路由：" + to); //新路由信息
        // console.log("上一个路由：" + from); //老路由信息
        // console.log(to.query);
        this.firstIndex = to.query.index;
        this.secondIndex = to.query.secondindex;
        if (!(typeof to.query.thirdindex === "undefined")) {
          this.thirdIndex = to.query.thirdindex;
        } else {
          this.thirdIndex == "-1";
        }
        $(window).scrollTop(0);
      },
    },
  },
  methods: {
    // 移动端判断
    appNavClick(index) {
      if (this.currentNav != index) {
        this.currentNav = index;
      } else {
        this.currentNav = -1;
      }
    },
  },
};
</script>
<style scoped>
</style>
